'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _useLocale = require('./_useLocale-BK3jOeaA.js');
require('react');
require('./IntlContext-BKfsnzBx.js');



exports.useLocale = _useLocale.useLocale;
